<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		/*text-align: center;*/
		color: #2c3e50;
		background: url(images/bg.png);
	}
	
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .5s
	}
	
	.fade-enter,
	.fade-leave-to {
		opacity: 0
	}
	
	#rightSeletWarpper::-webkit-scrollbar {
		/*滚动条整体样式*/
		width: 1px;
		/*高宽分别对应横竖滚动条的尺寸*/
		/*height: 4px;*/
		background-color: black;
	}
	
	#QRCodeWarpper {
		display: none;
		z-index: 9999;
	}
	
	span.communityContent:hover>img#QRCodeWarpper {
		display: block;
	}
</style>
<template>
	<div id="app">
		<!-- 头部 -->
		<div id="head" style="min-width: 1650px">
			<div class="language">
				<p v-text="defaultLanguage"></p>
				<img src="./images/icon/arrow_down.png" alt="language" class="arrow">
				<div style="bottom:-130px">
					<span id="firstLanguage" class="line3" @click="changeLanguage($event,'zw')">中文</span>
					<span class="line3" @click="changeLanguage($event,'hw')">한국어</span>
					<span class="line3" @click="changeLanguage($event,'yw')">English</span>
				</div>
			</div>
			<div class="navigation">
				<ul>
					<li>
						<img src="./images/icon/icon.png" alt="" class="shadowImg">
						<p v-text="dynamic"></p>
						<img src="./images/icon/arrow_down.png" alt="edg官网" class="arrow">
						<div class="selectWarpper" style="bottom:-135px">
							<span class="line3" @click="routerLink('nav1',language.news,'/home/journalism',$event)" v-text="language.news"></span>
							<span class="line3" @click="routerLink('nav1',language.video,'/home/videolist',$event)" v-text="language.video"></span>
							<span class="line3" @click="routerLink('nav1',language.wallpaper,'/home/wallpaper',$event)" v-text="language.wallpaper"></span>
						</div>
					</li>
					<li @click="joinEDG()">
						<img src="./images/icon/icon-4.png" alt="" class="shadowImg">
						<p v-text="language.joinEDG"></p>
						<!-- <img src="./images/icon/arrow_down.png" alt="edg官网"> -->
					</li>
					<li style="max-height:105px" @click="init()">
						<router-link to="/"><img src="./images/icon/logo-1.png" alt="" style="width:auto;height:100%"></router-link>
					</li>
					<li>
						<img src="./images/icon/icon-3.png" alt="" class="shadowImg">
						<p v-text="about"></p>
						<img src="./images/icon/arrow_down.png" alt="edg官网" class="arrow">
						<div class="selectWarpper" style="bottom:-185px">
							<span class="line3" @click="routerLink('nav2',language.weareEDG,'/home/weAreEDG',$event)" v-text="language.weareEDG"></span>
							<span class="line3" @click="routerLink('nav2',language.edgIntro,'/home/briefIntroduction',$event)" v-text="language.edgIntro"></span>
							<span class="line3" @click="routerLink('nav2',language.teameIntro,'/home/warTeam',$event)" v-text="language.teameIntro"></span>
							<span class="line3" @click="routerLink('nav2',language.rydtIntro,'/home/honor',$event)" v-text="language.rydtIntro"></span>
						</div>
					</li>
					<li>
						<img src="./images/icon/icon-2.png" alt="" class="shadowImg">
						<p v-text="language.EDGStore"></p>
						<img src="./images/icon/arrow_down.png" alt="edg官网" class="arrow">
						<div style="bottom:-55px">
							<!--<a href="https://mall.jd.com/index-598036.html" target="_blank"><span class="line3" v-text="language.jingdongStore"></span></a>-->
							<a href="https://edgteam.taobao.com/" target="_blank"><span class="line3" v-text="language.taobaoStore"></span></a>
						</div>
					</li>
				</ul>
			</div>
		</div>

		<!-- 主体 -->
		<router-view></router-view>

		<!-- 视频推荐 -->
		<transition name="fade">
			<div v-show="recommendation" id="recommendation" class="bgimg">
				<img class="remove" src="./images/icon/close.png" @click="recommendation=false;msg=0" />
				<article class="videoWarrper">
					<img class="videoMoreBtn" src="./images/icon/more.png" @click="moreBtnClick()" />
					<img class="line9" src="./images/icon/line9.png" />
					<div class="videoMask">
						<div class="leftContent">
							<h1 v-text="activeYer" style="font-size: 32px;">2017</h1>
							<p v-text="activeMonth" style="font-size: 25px;color: #0870c2;">7月</p>
						</div>
						<div class="rightContent">
							<!--轮播图-->
							<article class="swiper-container videoSwiper" style="height: 100%;">
								<div class="swiper-wrapper">
									<div class="swiper-slide swiper-no-swiping" style="height: 100%;width: 343.25px;" v-for="(item,index) in recommendVideoList">
										<div v-if="item=='999'"></div>
										<div v-else style="cursor: pointer;" :activeYer="computeTime(item.displayAt).substr(0,4)+'年'" :activeMonth="computeTime(item.displayAt).substr(5,2)" @click="playVideo(item)">
											<p style="margin: 0;background-color: black;overflow: hidden;height: 186px;line-height: 186px;">
												<img :src="item.imageUrl" style="width: 100%;vertical-align: middle;" />
											</p>
											<p v-text="item.title" style="width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;text-align: right;"></p>
											<p v-text="computeTime(item.displayAt)" style="text-align: right;"></p>
										</div>
									</div>
								</div>
							</article>
						</div>
					</div>
					<img class="line9" src="./images/icon/line9.png" />
					<img class="preNextBtn" src="./images/icon/ban_pre.png" style="left: 50px;" @click="preNextClick('pre')" />
					<img class="preNextBtn" src="./images/icon/ban_next.png" style="right: 50px;" @click="preNextClick('next')" />
				</article>
			</div>
		</transition>
		<div id="playVideoMask" v-show="isPlayVideo" class="bgimg" style="width: 100%;height: 100%;z-index: 9999;position: fixed;top: 0;">
			<img class="remove" src="./images/icon/close.png" @click="isPlayVideo=!isPlayVideo" />

		</div>

		<!-- 队员直播 -->
		<div v-if="livebroadcast" id="livebroadcast" class="bgimg">
			<img class="remove" src="./images/icon/close.png" @click="livebroadcast=false;msg=0" />
			<section style="width: 60%;height: 500px;margin: 8% auto 0 auto;display: flex;">
				<article id="leftLiveVideoWarpper" style="width: 800px;background-color: black;">
					<!--<iframe height=498 width=510 src='http://player.youku.com/embed/XMzcwMzY1MDc5Ng==' frameborder=0 'allowfullscreen'></iframe>-->
				</article>
				<article id="rightSeletWarpper" style="width: 200px;margin-left: 20px;color: white;position: relative;overflow-y:auto;">
					<div v-for="item in zhiboRoomDataList" style="text-align: center;">
						<h3 class="livebroadcastName" v-text="item.name" @click="isOpenClick(item)"></h3>
						<img class="line8" src="./images/icon/line8.png" />
						<ul :class="'oneWarpper oneWarpper'+item.id" style="padding: 0;margin: 0;">
							<li :id='subItem.id' class="roomName" v-for="subItem in item.rooms" v-text="subItem.name" @click="liveRoomClick(subItem)"></li>
						</ul>
					</div>
				</article>
			</section>
		</div>

		<!-- 底部 -->
		<div id="footer">
			<div class="tab">
				<span :class="msg==1?'clickBox':''" @click="msg=1,recommendation=true" style="color:#fff" v-text="language.videoRecommended"></span>
				<span :class="msg==2?'clickBox':''" @click="msg=2,livebroadcast=true" style="color:#fff" v-text="language.teamPlayslLive"></span>
				<a id="reserveAdv" :href="reserveAdvObj.hyperlink" target="_blank"><span style="color:#fff" v-text="language.registerStation"></span></a>
			</div>
			<div class="box">
				<div>
					<div>
						<span v-text="language.edgCommunity"></span>
						<span class="line2"></span>
					</div>
					<div style="margin-top: 10px;">
						<p id="communityWarpper">
							<span class="communityContent" v-for="item in communityDataList" style="position:relative;font-size: 0;">
								<img class="communityItem"  :data-type="item.type" :data-src="item.hyperlink" :src="item.imageUrl" @click="communityItemClick(item)" />
								<img id="QRCodeWarpper" v-if="item.type==1" :src="item.hyperlink" style="width: 150px;height: auto;position: absolute;top: -195px;left:-44px;" />
							</span>
						</p>
					</div>
				</div>
				<div>
					<div>
						<span v-text="language.followUs"></span>
						<span class="line2"></span>
					</div>

					<div style="margin-top: 10px">
						<a class="icon wx_a" href="#" target="_blank"></a>
					</div>
				</div>
				<div>
					<div>
						<span v-text="language.relatedLinks">相关链接</span>
						<span class="line2"></span>
					</div>
					<div style="margin-top: 10px;text-align: left;box-sizing: border-box;padding-left: 30%;">
						<p class="relatedLinksWarpper" v-for="item in linkDataList">
							<span>
								<img :src="item.imageUrl" />
								<a v-text="item.name" @click="hyperlinkClick(item)" :title="item.name"></a>
							</span>
						</p>
					</div>
				</div>
			</div>
			<p style="text-align: center;margin:10px 0;">EDG俱乐部团队 ® 2016 All Rights Reserved | 上海阳川电子科技有限公司</p>
		</div>
	</div>
</template>

<script>
	var _this;
	import Swiper from 'swiper';
	import 'swiper/dist/css/swiper.min.css';
	export default {
		name: 'App',
		data() {
			return {
				linkDataList: [], // 相关链接数据列表
				communityDataList: [], // 社区数据列表
				recommendVideoList: [], // 推荐视频数据列表
				zhiboRoomDataList: [], // 直播间数据列表
				videoSwiperObj: {}, // 视频推荐页面轮播组件对象
				reserveAdvObj: {}, // 预留广告位对象
				recommendation: false, //视频推荐
				livebroadcast: false, //队员直播
				defaultLanguage: 'language', // 默认
				msg: 0,
				dynamic: 'EDG动态', //动态下拉
				about: '关于EDG', //关于下拉
				// 推荐视频
				activeYer: '', // 当前页年
				activeMonth: '', // 当年页月
				isPlayVideo: false, // 是否显示播放界面

				language: {
					// 顶部导航栏
					dynamic: 'EDG动态',
					news: '新闻',
					video: '视频',
					wallpaper: '壁纸',

					joinEDG: '加入EDG',

					aboutEDG: '关于EDG',
					weareEDG: 'We are EGG',
					edgIntro: 'EDG简介',
					teameIntro: '战队介绍',
					rydtIntro: '荣誉殿堂',

					EDGStore: 'EDG商城',
					jingdongStore: '京东商城',
					taobaoStore: '淘宝商城',

					// 中部导航栏
					videoRecommended: '视频推荐',
					teamPlayslLive: '队员直播',
					registerStation: '预留广告位',

					// 底部导航栏
					edgCommunity: 'EGD社区',
					followUs: '关注我们',
					relatedLinks: '相关链接',
					pphz: '品牌合作',
					contactUs: '联系我们',
				},
			}
		},
		//监听
		watch: {
			// 路由变化监听
			$route(to, from) {
				if(to.path == '/') {
					this.dynamic = this.language.dynamic;
					this.about = this.language.aboutEDG;
					$('.selectWarpper span').css('color', 'white')
				}
			},
			recommendation: function(val) {
				if(val) {
					$('html').css('overflow', 'hidden');
					this.getRecommendationData(0)
				} else {
					$('html').css('overflow', 'auto');
					this.videoSwiperObj = {};
				}
			},
			livebroadcast: function(val) {
				if(val) {
					function demo() {
						var flag = false;
						if(window.ActiveXObject) {
							try {
								var swf = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
								if(swf) {
									flag = true;
								}
							} catch(e) {}
						} else {
							try {
								var swf = navigator.plugins['Shockwave Flash'];
								if(swf) {
									flag = true;
								}
							} catch(e) {}
						}
						if(flag) {
							$('html').css('overflow', 'hidden');
							_this.getLivebroadcastData(0)
						} else {
							alert("flash已禁用");
						}
					}
					demo()
				} else {
					$('html').css('overflow', 'auto');
				}
			},
			isPlayVideo: function(e) {

			}
		},
		mounted: function() {
			_this = this;

			// 设置语音默认选中颜色
			$('#firstLanguage').css('color', '#0090ff');

			// 获取预留广告位
			this.getReservedData();

			// 获取社区列表
			this.getCommunityList();

			// 获取相关链接列表
			this.getLinkList();

			// 动态显示-隐藏导航栏下拉框
			$('#head div.navigation>ul li,#head div.language').hover(function(e) {
				$(e.currentTarget).find('div').css('display', 'block');
			}, function(e) {
				$(e.currentTarget).find('div').css('display', 'none');
			})

		},
		//事件处理
		methods: {
			// 相关链接点击事件
			hyperlinkClick: function(item) {
				if(item.id == 1 || item.id == 2) { // 品牌合作-联系我们
					this.$router.push({
						path: '/home/contactUs'
					});
				} else {
					window.open(item.hyperlink)
				}
			},
			// 语言切换
			changeLanguage: function(ev, name) {
				switch(name) {
					case 'zw': // 中文
						this.language = {
							dynamic: 'EDG动态',
							news: '新闻',
							video: '视频',
							wallpaper: '壁纸',

							joinEDG: '加入EDG',

							aboutEDG: '关于EDG',
							weareEDG: 'We are EGG',
							edgIntro: 'EDG简介',
							teameIntro: '战队介绍',
							rydtIntro: '荣誉殿堂',

							EDGStore: 'EDG商城',
							jingdongStore: '京东商城',
							taobaoStore: '淘宝商城',

							// 中部导航栏
							videoRecommended: '视频推荐',
							teamPlayslLive: '队员直播',
							registerStation: this.reserveAdvObj.text, // 预留广告位

							// 底部导航栏
							edgCommunity: 'EGD社区',
							followUs: '关注我们',
							relatedLinks: '相关链接',
							pphz: '品牌合作',
							contactUs: '联系我们',
						};
						break
					case 'hw': // 韩文
						this.language = {
							dynamic: 'EDG동태',
							news: '뉴스',
							video: '비디오',
							wallpaper: '웰페이퍼',

							joinEDG: 'EDG가입',

							aboutEDG: 'EDG관련',
							weareEDG: 'We are EDG',
							edgIntro: 'EDG클럽 소개',
							teameIntro: '팀 소개',
							rydtIntro: '명예의 전당',

							EDGStore: 'EDG스토어',
							jingdongStore: 'JD스토어',
							taobaoStore: 'Tao Bao',

							// 中部导航栏
							videoRecommended: '추천 비디오', // 视频推荐
							teamPlayslLive: '팀원 방송', // 队员直播
							registerStation: this.reserveAdvObj.textKo, // 预留广告位

							// 底部导航栏
							edgCommunity: 'EDG커뮤니티',
							followUs: '팔로우 하기', // 关注我们
							relatedLinks: '관련 링크', //相关链接
							pphz: '공동 브랜딩', //品牌合作
							contactUs: '연락 방식', // 联系我们
						};
						break
					case 'yw': // 英文
						this.language = {
							dynamic: 'EDG Activities',
							news: 'News',
							video: 'Video',
							wallpaper: 'Wallpaper',

							joinEDG: 'Join EDG',

							aboutEDG: 'About EDG',
							weareEDG: 'we are EDG',
							edgIntro: 'EDG Introduction',
							teameIntro: 'Team Introduction',
							rydtIntro: 'trophy wall',

							EDGStore: 'EDG Store',
							jingdongStore: 'Joybuy Store',
							taobaoStore: 'Tao Bao',

							// 中部导航栏
							videoRecommended: 'Recommended Video',
							teamPlayslLive: 'Player Streaming',
							registerStation: this.reserveAdvObj.textEn, // 预留广告位

							// 底部导航栏
							edgCommunity: 'EDG Community',
							followUs: 'Follow Us',
							relatedLinks: 'Related Link',
							pphz: 'Co-branding',
							contactUs: 'Contact Us',
						};
						break
				}
				this.defaultLanguage = $(ev.currentTarget).text();
				this.dynamic = this.language.dynamic;
				this.about = this.language.aboutEDG;

				$("a[title='品牌合作']").text(this.language.pphz);
				$("a[title='联系我们']").text(this.language.contactUs);

				$(ev.currentTarget).parent().css('display', 'none');
				$(ev.currentTarget).parent().css('display', 'none').children('span').css('color', 'white');
				$(ev.currentTarget).css('color', '#0090ff');

			},
			// EDG社区链接跳转
			communityItemClick: function(item) {
				if(item.type == '1') return;
				window.open(item.hyperlink);
			},
			// 打开直播列表
			isOpenClick: function(item) {
				if(item.rooms == undefined || item.rooms.length == 0) return;
				$('.oneWarpper').stop(true, false).slideUp();
				$('.oneWarpper' + item.id).stop(true, false).slideToggle();
			},
			// 打开直播房间
			liveRoomClick: function(item) {
				$('.roomName').css('color', 'white')
				$('.roomName#' + item.id).css('color', '#0090ff')
				$('#leftLiveVideoWarpper').empty()
				$('#leftLiveVideoWarpper').append("<iframe height=498 width=510 src='' frameborder=0 'allowfullscreen'></iframe>")
				$('#leftLiveVideoWarpper>iframe').attr('src', item.hyperlink)
				$('#leftLiveVideoWarpper iframe,#leftLiveVideoWarpper video,#leftLiveVideoWarpper embed').css({
					'width': '100%',
					'display': 'block',
					'margin': '0 auto'
				})
			},
			// 时间戳计算
			computeTime: function(d) {
				return this.appfn.creatTime(d).substr(0, 10);
			},

			// 更多视频
			moreBtnClick: function() {
				window.scrollTo(0, 0);
				this.recommendation = !this.recommendation;
				this.$router.push({
					path: '/home/videolist'
				});
			},
			// 轮播图上一页-下一页
			preNextClick: function(name) {
				if(this.videoSwiperObj.slidePrev == undefined) {
					this.initSwiper();
				}
				name == 'pre' ? this.videoSwiperObj.slidePrev() : this.videoSwiperObj.slideNext();
				this.activeYer = $('.videoSwiper .swiper-slide-active>div').attr('activeyer');
				this.activeMonth = $('.videoSwiper .swiper-slide-active>div').attr('activeMonth') + '月';
			},
			// 播放推荐视频
			playVideo: function(item) {
				$('#playVideoMask iframe,#playVideoMask video,#playVideoMask embed').remove();
				$('#playVideoMask').append(item.hyperlink);
				$('#playVideoMask iframe,#playVideoMask video,#playVideoMask embed').css({
					'width': '864px',
					'height': '648px',
					'display': 'block',
					'margin': '10% auto'
				})
				setTimeout(function() {
					this.isPlayVideo = !this.isPlayVideo;
				}.bind(this), 500)
			},
			// 轮播图初始化
			initSwiper: function() {
				this.videoSwiperObj = new Swiper('.videoSwiper', {
					slidesPerView: 4,
					spaceBetween: 30,
					slidesPerGroup: 4,
					observer: true,
					observeParents: true,
					loop: true,
					delay: 4000,
					speed: 1000,
				});
				this.activeYer = $('.videoSwiper .swiper-slide-active>div').attr('activeyer');
				this.activeMonth = $('.videoSwiper .swiper-slide-active>div').attr('activeMonth') + '月';
			},
			// 导航栏路由链接跳转
			routerLink: function(flag, name, path, ev) {
				if(flag == 'nav1') {
					this.dynamic = name;
				} else if(flag == 'nav2') {
					this.about = name;
				}

				this.$router.push({
					path: path
				});
				$(ev.currentTarget).parent().css('display', 'none').children('span').css('color', 'white');
				$(ev.currentTarget).css('color', '#0090ff');

			},
			// 加入EDG
			joinEDG: function() {
				window.open('http://xls.edgteam.cn/apply/index.html');

			},

			// 初始化导航栏显示
			init: function() {
				this.msg = 0;
				this.dynamic = this.language.dynamic;
				this.about = this.language.aboutEDG;
			},
			//--------------------------------------------------------------------------------
			//获取推荐视频数据
			getRecommendationData: function(n) {
				this.request.get({
					url: '/edg/video',
					params: {
						'condition': 'home=1&condition=show=1',
						'orderBy': '-DisplayAt&orderBy=Sort',
					},
					callback: function(result) {
						if(result.data.length == 0) return;

						var videos = {};
						if(result.code == 0) {
							// 改变原始数据结构体
							for(let i = result.data.length - 1; i >= 0; i--) {
								let video = {};
								video[result.data[i].month] = result.data[i];
								if(videos[result.data[i].year] == undefined) {
									videos[result.data[i].year] = {};
								}
								if(videos[result.data[i].year][result.data[i].month] == undefined) {
									videos[result.data[i].year][result.data[i].month] = []
								}
								videos[result.data[i].year][result.data[i].month].push(video)
							}
							// 造假数据
							var tempArray = [];
							var tem = [];
							for(var keys in videos) {
								for(var month in videos[keys]) {
									if(videos[keys][month].length % 4 != 0) {
										for(var j = videos[keys][month].length % 4; j < 4; j++) {
											videos[keys][month].unshift({
												month: '999'
											})
										}
									}
								}
							}
							for(var keys in videos) {
								for(var month in videos[keys]) {
									for(var j = 0; j < videos[keys][month].length; j++) {
										tempArray.push(videos[keys][month][j])
									}
								}

							}

							for(var t in tempArray) {
								for(var h in tempArray[t]) {
									tem.push(tempArray[t][h]);
								}
							}
						}

						this.recommendVideoList = tem.reverse();
						console.log(this.recommendVideoList)
						setTimeout(function() {
							this.initSwiper();
						}.bind(this), 300);

					}.bind(this)
				})

			},

			//获取队员直播数据
			getLivebroadcastData: function(n) {
				this.request.get({
					url: '/live/category',
					params: {
						'condition': 'status=0'
					},
					callback: function(d) {
						if(d.data.length == 0)
							return;
						this.zhiboRoomDataList = d.data;
						setTimeout(function() {
							for(var i = 0; i < this.zhiboRoomDataList.length; i++) {
								if(this.zhiboRoomDataList[i].rooms && this.zhiboRoomDataList[i].rooms.length) {
									$('.oneWarpper' + this.zhiboRoomDataList[i].id).stop(true, false).slideToggle();
									$('.roomName#' + this.zhiboRoomDataList[i].rooms[0].id).css('color', '#0090ff');
									$('#leftLiveVideoWarpper').append("<iframe height=498 width=510 src='' frameborder=0 'allowfullscreen'></iframe>")
									$('#leftLiveVideoWarpper>iframe').attr('src', this.zhiboRoomDataList[i].rooms[0].hyperlink)
									$('#leftLiveVideoWarpper iframe,#leftLiveVideoWarpper video,#leftLiveVideoWarpper embed').css({
										'width': '100%',
										'display': 'block',
										'margin': '0 auto'
									})
									return;
								}
							}
						}.bind(this), 0)
					}.bind(this)
				})

			},
			//获取预留广告位
			getReservedData: function(n) {
				this.request.get({
					url: '/ad/reserve/1',
					params: {
						//						'condition': 'status=0'
					},
					callback: function(d) {
						if(d.data == undefined || d.data.status == 1) {
							$('#reserveAdv span').css('display', 'none');
							return;
						} else {
							this.reserveAdvObj = d.data;
							$('#reserveAdv span').css('display', 'inline-block');
							this.language.registerStation = this.reserveAdvObj.text;

						}
					}.bind(this)
				})

			},
			//获取相关链接数据列表
			getLinkList: function(n) {
				this.request.get({
					url: '/ad/link',
					params: {
						'condition': 'status=0'
					},
					callback: function(d) {
						this.linkDataList = d.data;
					}.bind(this)
				})

			},
			// 获取社区列表
			getCommunityList: function() {
				this.request.get({
					url: '/ad/we-media',
					params: {
						'condition': 'status=0'
					},
					callback: function(d) {
						this.communityDataList = d.data;
					}.bind(this)
				})

			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/App.vue